import { render, staticRenderFns } from "./list-component.vue?vue&type=template&id=a64f607c&scoped=true&lang=html"
import script from "./list-component.vue?vue&type=script&lang=js"
export * from "./list-component.vue?vue&type=script&lang=js"
import style0 from "./list-component.vue?vue&type=style&index=0&id=a64f607c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64f607c",
  null
  
)

export default component.exports